import { render, staticRenderFns } from "./EditorPage.vue?vue&type=template&id=cf52ee3a&scoped=true&"
import script from "./EditorPage.vue?vue&type=script&lang=ts&"
export * from "./EditorPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditorPage.vue?vue&type=style&index=0&id=cf52ee3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf52ee3a",
  null
  
)

export default component.exports